import styled from 'styled-components';

import { scale090, space4XL } from '@xing-com/tokens';

export const Wrapper = styled.div`
  padding: ${space4XL} 0;
  display: flex;
  flex-direction: column;
  gap: ${space4XL};
`;
export const TopSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${scale090};
`;
